export default {
  meta: {
    title: 'Location',
  },
};
